export default __webpack_public_path__ + "static/media/onze.ecbfdb81.jpg";